<app-section-loader *ngIf="isLoadingSubject | async; else previewTpl" />

<ng-template #previewTpl>
  <div [ngClass]="customClass">
    <ng-container *ngFor="let doc of data; index as i; trackBy: trackByUrl">
      <ng-container
        [ngTemplateOutlet]="getType(doc) === 'FILE' ? previewFile : previewImage"
        [ngTemplateOutletContext]="{ data: doc, index: i }"
      >
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<!-- preview document -->
<ng-template #previewFile let-data="data" let-index="index">
  <div
    class="position-relative mw-100"
    [ngClass]="!!customClass ? '' : 'm-auto'"
    [class.mt-8]="index > 0 && !customClass"
  >
    <div
      class="file-download card-rounded d-flex align-items-center shadow-xs p-6"
      [class.opacity-25]="isLoadingSubject | async"
    >
      <button
        (click)="handleDownload(data)"
        class="d-flex align-items-center w-100 bg-transparent border-0"
        [disabled]="isLoadingSubject | async"
      >
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_FILE_PDF" class="svg-icon svg-icon-32"></span>
        <div class="col-auto ms-4 text-start">
          <span class="d-block mb-1">{{ data.name || 'file.pdf' }}</span>
          <span class="d-block text-gray-700" *ngIf="data.size"
            >{{ data.size | number: '1.2-2' }} Mb</span
          >
        </div>
      </button>
    </div>
  </div>
</ng-template>

<!-- preview image -->
<ng-template #previewImage let-data="data" let-index="index">
  <div [class.mt-8]="index > 0 && !customClass">
    <app-image-preview
      [image]="data.url"
      [height]="imageHeight ?? 200"
      [width]="imageWidth"
      [borderRadius]="imageBorderRadius"
      [openTextLabel]="false"
      [imgClass]="imageClass"
    />
  </div>
</ng-template>
